module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/background-conscription.feed753f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/background-conscription.png
// module id = 2824
// module chunks = 11